// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__URiuy","title":"Navbar_title__YUewJ"};